"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbDynamic = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const BreadcrumbDynamicText_1 = require("./BreadcrumbDynamicText");
const Typography_1 = require("../Typography/Typography");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
function BreadcrumbDynamic({ itemTitle, urlPath, className = '' }) {
    const pathWithoutQuery = urlPath.split('?')[0];
    let pathTitles = pathWithoutQuery.split('/').filter((path) => path !== '');
    const home = {
        href: '/',
        label: 'Home'
    };
    const breadcrumbs = [
        home,
        ...pathTitles.map((path, index) => {
            if (itemTitle && path[0] === '[' && path[path.length - 1] === ']') {
                path = itemTitle;
            }
            const cleanPath = path === null || path === void 0 ? void 0 : path.split('-');
            const upperCasedPath = cleanPath
                .map((title) => {
                return title[0].toUpperCase() + title.substring(1);
            })
                .join(' ');
            const href = '/' + pathTitles.slice(0, index + 1).join('/');
            return {
                href,
                label: upperCasedPath
            };
        })
    ];
    return ((0, jsx_runtime_1.jsx)("ol", Object.assign({ className: (0, classnames_1.default)('flex', 'items-center', 'text-silver-90', className) }, { children: breadcrumbs.map((crumb, index) => ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: index === breadcrumbs.length - 1 ? ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ as: "span", "aria-hidden": true, variant: "h200", className: "ml-5" }, { children: crumb.label }), `separator-${index}`) }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BreadcrumbDynamicText_1.BreadcrumbDynamicText, { crumb: crumb }, `child-${index}`), (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ as: "span", "aria-hidden": true, variant: "h200", className: "ml-5" }, { children: "/" }), `separator-${index}`)] })) }, index))) })));
}
exports.BreadcrumbDynamic = BreadcrumbDynamic;
//# sourceMappingURL=BreadcrumbDynamic.js.map